export default __webpack_public_path__ + "static/media/dog.cde07528.png";